import styled from 'styled-components';
import {colorPalette} from '../../Config/colorConfig.js'

const ButtonIcon = styled.img`
    cursor:'pointer';
    position: relative;
    width: 2rem;
    height: auto;
    border: none;
    margin-right:3px;
`

const Button = styled.button`
    cursor:'pointer';
    display:flex;
    flex-direction:row;
    align-items: center;
    color: #FFF;
    background-color: ${colorPalette.myYellow};
    margin:5px;
    border:none;
    border-radius: 5px ;
    padding:6px 6px;
    font-size:1rem;
    font-weight: 900;
    letter-spacing: 2px;
    box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.25);
    &:hover {
        box-shadow: inset 3px 3px 4px rgba(255, 255, 255, 0.5);
    }
    &:active,&:focus,&:visited{
        border:none;
        outline: none;
    }
`

export {
    ButtonIcon,
    Button,
}